import { createFeature, createReducer, on } from '@ngrx/store';
import { Tag } from '@qtek/shared/models';
import { TagManagerActions } from './tag-manager.actions';

export interface TagManagerState {
  tags: Tag[];
  error: Error | null;
  isLoading: boolean;
}

export const tagManagerInitialState: TagManagerState = {
  tags: [],
  error: null,
  isLoading: false,
};
export const TagManagerReducer = createReducer(
  tagManagerInitialState,
  on(TagManagerActions.connectTags, state => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(TagManagerActions.queryTagsSuccess, (state, { tags }) => {
    return {
      ...state,
      tags,
      isLoading: false,
    };
  }),
  on(TagManagerActions.queryTagsFailure, state => {
    return {
      ...state,
      isLoading: false,
    };
  }),
  on(TagManagerActions.createTagSuccess, (state, { tag }) => {
    return {
      ...state,
      tags: [...state.tags, tag],
    };
  }),
  on(TagManagerActions.deleteTagSuccess, (state, { tag }) => {
    return {
      ...state,
      tags: state.tags.filter(currTag => currTag._id !== tag._id),
    };
  }),
  on(TagManagerActions.updateTagSuccess, (state, { tag }) => {
    return {
      ...state,
      tags: state.tags.map(currTag => {
        if (currTag._id === tag._id) {
          return tag;
        }

        return currTag;
      }),
    };
  })
);

export const TagManagerFeature = createFeature({
  name: 'TagManagerKey',
  reducer: TagManagerReducer,
});
